<!-- Modo página normal: com po-page-default + breadcrumb -->
<ng-container *ngIf="!modalMode">
  <!-- po-page-default, e não po-page-detail: aquele só tem três saídas fixas
       (voltar/editar/remover), e as ações do review são quatro num Pull Request. Aqui
       elas são dados, com visibilidade própria. -->
  <po-page-default
    [p-title]="pageTitle"
    [p-breadcrumb]="breadcrumb"
    [p-actions]="pageActions">
    <div class="sr-page-shell">
      <ng-container *ngTemplateOutlet="shellContent"></ng-container>
    </div>
  </po-page-default>
</ng-container>

<!-- Modo modal: só o conteúdo interno, sem wrapper de página -->
<ng-container *ngIf="modalMode">
  <div class="sr-page-shell sr-modal-shell">
    <ng-container *ngTemplateOutlet="shellContent"></ng-container>
  </div>
</ng-container>

<ng-template #shellContent>

  <!-- Identificação (só no modo normal) -->
  <div class="po-row po-mt-2 sr-meta-row" *ngIf="!importedMode && !sourceOnly">
    <div class="po-md-12 sr-surface sr-meta-surface">
      <div class="po-row">
        <po-info
          class="po-sm-12 po-md-2"
          p-label="Tipo"
          [p-value]="resourceTypeLabel || 'n/d'">
        </po-info>
        <!-- A origem qualifica o identificador, então vem antes dele. Some quando o
             repositório de um review git foi descadastrado: rótulo vazio seria pior que
             rótulo nenhum. -->
        <po-info
          class="po-sm-12 po-md-2"
          p-label="Origem"
          [p-value]="reviewProviderLabel"
          *ngIf="reviewProviderLabel">
        </po-info>
        <!-- Some quando só repetiria o título da página, como "grr-api #859649" num PR. -->
        <po-info
          class="po-sm-12 po-md-2"
          [p-label]="reviewVersionTitle"
          [p-value]="reviewChangesetLabel || 'n/d'"
          *ngIf="(isComparison || isGitComparison || isChangeset || isGitChange) && reviewChangesetLabel !== pageTitle">
        </po-info>
        <po-info
          class="po-sm-12 po-md-3"
          p-label="Arquivo analisado"
          [p-value]="reviewSourceLabel || 'n/d'"
          *ngIf="isStandalone">
        </po-info>
        <po-info
          class="po-sm-12 po-md-2"
          p-label="Solicitado por"
          [p-value]="reviewRequestedBy || 'n/d'">
        </po-info>
        <po-info
          class="po-sm-12 po-md-2"
          p-label="Solicitado em"
          [p-value]="reviewRequestedAt ? (reviewRequestedAt | date:'dd/MM/yyyy HH:mm') : 'n/d'">
        </po-info>
        <po-info
          class="po-sm-12 po-md-2"
          p-label="Última atividade"
          [p-value]="reviewLastActivityAt ? (reviewLastActivityAt | date:'dd/MM/yyyy HH:mm') : 'n/d'">
        </po-info>
        <po-info
          class="po-sm-12 po-md-2"
          [p-label]="retryInfoLabel"
          [p-value]="showRetryActor
            ? ('@' + reviewLastRetryBy + (reviewLastRetryAt ? (' em ' + (reviewLastRetryAt | date:'dd/MM/yyyy HH:mm')) : ''))
            : (reviewLastRetryAt ? (reviewLastRetryAt | date:'dd/MM/yyyy HH:mm') : 'n/d')"
          *ngIf="reviewLastRetryBy || reviewLastRetryAt">
        </po-info>
      </div>

      <!-- O resultado da publicação fica no bloco do review, junto do resto que descreve
           o review. A ação em si vive no cabeçalho, com as outras ações de review. -->
      <div class="po-row sr-publish-row" *ngIf="publishCommentsSummary">
        <div class="po-md-12 sr-publish-bar">
          <span class="sr-publish-summary">{{ publishCommentsSummary }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Review com erro aberto por quem tem visão global: o conteúdo é o que ficou gravado,
       muitas vezes de uma execução anterior que deu certo. Sem este aviso ele passava pelo
       resultado atual — o reprocessamento que falhou não aparecia em lugar nenhum. -->
  <div class="po-row po-mt-2 sr-meta-row" *ngIf="isFailedReview && !reviewAccessDenied && !loading">
    <div class="po-md-12 sr-surface sr-meta-surface sr-surface-warning" role="status">
      <div class="po-row">
        <po-info class="po-sm-12" [p-label]="failedReviewNotice.title" [p-value]="failedReviewNotice.text"></po-info>
      </div>
    </div>
  </div>

  <!-- Sem acesso ao review: a API recusa arquivos, achados e diff. Em vez do viewer vazio,
       que parecia um review sem alteração, diz o motivo e o que fazer. -->
  <div class="po-row po-mt-2 sr-meta-row" *ngIf="reviewAccessDenied && !loading">
    <div class="po-md-12 sr-surface sr-meta-surface sr-surface-warning" role="status">
      <div class="po-row">
        <po-info class="po-sm-12" [p-label]="reviewAccessNotice.title" [p-value]="reviewAccessNotice.text"></po-info>
      </div>
    </div>
  </div>

  <!-- Modo só-fonte: renderiza apenas o visualizador de código (sem meta/abas) -->
  <ng-container *ngIf="sourceOnly && !reviewAccessDenied">
    <po-loading-overlay *ngIf="loading" p-size="md" p-text="Carregando"></po-loading-overlay>
    <div class="sr-source-only">
      <ng-container *ngTemplateOutlet="sourceViewerTpl"></ng-container>
    </div>
  </ng-container>

  <!-- Abas de análise -->
  <po-tabs *ngIf="!importedMode && !sourceOnly && !reviewAccessDenied">

    <po-tab
      p-label="Code Review"
      [p-active]="isCodeReviewMode"
      (p-click)="setAnalysisMode('code_review')">

      <!-- Seletor de arquivo -->
      <div class="po-row sr-file-row" *ngIf="files.length > 0 && !isStandalone">
        <div class="po-md-12 sr-surface sr-file-surface">
          <!-- Uma linha, um rótulo: o combo ocupa o que sobra, a posição fica colada nele e
               o filtro traz a própria contagem. Em flex, e não em colunas do grid, o combo
               se ajusta sozinho quando a navegação ou o filtro não aparecem. -->
          <div class="sr-file-selector">
            <!-- po-combo com filtro "contains": PRs grandes têm centenas de arquivos e o
                 usuário procura pelo nome, não pelo prefixo do caminho. -->
            <po-combo
              #fileCombo
              class="sr-file-combo"
              name="fileSelector"
              p-label="Arquivo"
              p-placeholder="Digite parte do caminho para filtrar"
              p-filter-mode="contains"
              p-remove-initial-filter="true"
              [p-options]="fileOptions"
              [(ngModel)]="selectedFileValue"
              (p-change)="onFileChange($event)">
            </po-combo>

            <!-- A troca por Alt+↑/↓ já existia, mas não aparecia em lugar nenhum da tela.
                 Com um arquivo só não há para onde ir, e a navegação não aparece. -->
            <div class="sr-file-nav" *ngIf="files.length > 1">
              <po-button
                p-kind="tertiary"
                p-icon="po-icon-arrow-left"
                p-tooltip="Arquivo anterior (Alt+↑)"
                p-tooltip-position="top"
                p-append-in-body="true"
                [attr.aria-label]="'Arquivo anterior'"
                [p-disabled]="visibleFiles.length < 2"
                (p-click)="selectPreviousFile()">
              </po-button>
              <span class="sr-file-nav-position">{{ filePositionLabel }}</span>
              <po-button
                p-kind="tertiary"
                p-icon="po-icon-arrow-right"
                p-tooltip="Próximo arquivo (Alt+↓)"
                p-tooltip-position="top"
                p-append-in-body="true"
                [attr.aria-label]="'Próximo arquivo'"
                [p-disabled]="visibleFiles.length < 2"
                (p-click)="selectNextFile()">
              </po-button>
            </div>

            <!-- Mesmo par de botões do "Lado | Inline" do diff: o escolhido em secondary, o
                 outro em tertiary. Cada opção traz o tamanho da lista que ela mostra. Só
                 aparece quando recorta alguma coisa. -->
            <div class="sr-file-filter" *ngIf="showFindingsFilter">
              <div class="sr-file-filter-toggle" role="group" aria-label="Arquivos no seletor">
                <po-button
                  [p-kind]="!onlyFilesWithFindings ? 'secondary' : 'tertiary'"
                  [p-label]="allFilesFilterLabel"
                  (p-click)="onOnlyFilesWithFindingsChange(false)">
                </po-button>
                <po-button
                  [p-kind]="onlyFilesWithFindings ? 'secondary' : 'tertiary'"
                  [p-label]="findingsFilterLabel"
                  (p-click)="onOnlyFilesWithFindingsChange(true)">
                </po-button>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Visão Geral -->
      <div class="po-row po-mt-2 sr-overview-row" *ngIf="answer && !loading">
        <div class="po-md-12 sr-block-overview">
          <div class="sr-overview-panel" [class.sr-overview-panel--collapsed]="overviewCollapsed">

            <div class="sr-overview-panel-header" (click)="toggleOverview()">
              <span class="sr-overview-panel-chevron">{{ overviewCollapsed ? '▸' : '▾' }}</span>
              <span class="sr-overview-panel-title">Visão Geral</span>
              <span class="sr-overview-panel-chips" *ngIf="answer.summary">
                <po-tag *ngIf="answer.summary.status"
                    [p-value]="answer.summary.status"
                    [p-type]="getSummaryStatusType(answer.summary.status)"
                    p-inverse="true"
                    [p-tooltip]="statusTooltip"
                    p-tooltip-position="top"
                    p-append-in-body="true"
                    (click)="$event.stopPropagation()">
                </po-tag>
                <po-tag *ngIf="answer.summary.score != null"
                    [p-value]="'Score: ' + answer.summary.score"
                    p-type="info"
                    p-inverse="true"
                    [p-tooltip]="scoreTooltip"
                    p-tooltip-position="top"
                    p-append-in-body="true"
                    (click)="$event.stopPropagation()">
                </po-tag>

              </span>
            </div>

            <div class="sr-overview-panel-body" *ngIf="!overviewCollapsed">
              <div class="sr-overview-panel-section sr-overview-panel-section--understanding" *ngIf="answer.understanding">
                <div class="sr-overview-panel-section-title">Entendimento</div>
                <div class="sr-overview-panel-text sr-md-content" [innerHTML]="answer.understanding | markdown"></div>
              </div>
              <div class="sr-overview-panel-section" *ngIf="answer.positives?.length">
                <div class="sr-overview-panel-section-title">Pontos Positivos</div>
                <ul class="sr-overview-panel-list">
                  <li *ngFor="let pos of answer.positives" class="sr-md-content" [innerHTML]="pos | markdown"></li>
                </ul>
              </div>
              <!-- Sem entendimento nem pontos positivos o corpo saía em branco, e um card
                   vazio parece defeito. Dizer que não houve detalhamento é informação. -->
              <div class="sr-overview-panel-empty" *ngIf="!hasOverviewDetail">
                O modelo não detalhou esta análise — as etiquetas acima resumem o resultado.
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Monaco Viewer (Diff + Standalone) -->
      <ng-container *ngTemplateOutlet="sourceViewerTpl"></ng-container>

      <div class="sample-container" *ngIf="loading">
        <po-loading-overlay></po-loading-overlay>
      </div>

    </po-tab>

    <po-tab
      p-label="Entendimento Técnico"
      [p-active]="isTechnicalDocMode"
      [p-disabled]="isTechnicalDocProcessing"
      (p-click)="onTechnicalDocTabClick()">

      <div class="po-md-12">
        <div class="sr-surface sr-techdoc-surface">
          <div class="sr-techdoc-toolbar">
            <div class="sr-techdoc-toolbar-left">
              <strong>Entendimento Técnico</strong>
              <po-tag
                *ngIf="technicalDocJob?.status"
                [p-value]="technicalDocJob?.status || 'n/d'"
                [p-type]="getTechnicalDocStatusType(technicalDocJob?.status)"
                p-inverse="true">
              </po-tag>
            </div>
            <div class="sr-techdoc-toolbar-right">
              <po-button
                p-kind="secondary"
                p-icon="po-icon-refresh"
                p-label="Atualizar"
                [p-disabled]="technicalDocLoading || technicalDocActionLoading"
                (p-click)="refreshTechnicalDoc()">
              </po-button>
              <po-button
                *ngIf="technicalDocAvailable && technicalDocAnswer"
                p-kind="secondary"
                p-icon="po-icon-copy"
                p-label="Copiar"
                [p-disabled]="technicalDocLoading"
                (p-click)="copyTechnicalDocAsText()">
              </po-button>
              <po-button
                *ngIf="!technicalDocAvailable && canRun"
                p-kind="primary"
                p-icon="po-icon-plus"
                [p-label]="isTechnicalDocProcessing ? 'Gerando...' : 'Gerar Entendimento Técnico'"
                [p-disabled]="isTechnicalDocProcessing"
                (p-click)="requestTechnicalDocGeneration()">
              </po-button>
              <po-button
                *ngIf="technicalDocAvailable && canRun"
                p-kind="secondary"
                p-icon="po-icon-refresh"
                p-label="Regerar"
                [p-disabled]="technicalDocLoading || technicalDocActionLoading || !technicalDocJob?.jobId"
                (p-click)="retryTechnicalDoc()">
              </po-button>
            </div>
          </div>

          <div class="sr-techdoc-status" *ngIf="technicalDocStatusMessage || (!technicalDocLoading && !technicalDocAnswer)">
            {{ technicalDocStatusMessage || 'Entendimento técnico não foi gerado para este review.' }}
          </div>

          <div class="sample-container" *ngIf="technicalDocLoading">
            <po-loading-overlay></po-loading-overlay>
          </div>

          <div class="sr-techdoc-content" *ngIf="!technicalDocLoading && technicalDocAnswer as tech">
            <po-accordion>

              <po-accordion-item p-label="Resumo Executivo" *ngIf="tech.executive_summary">
                <p *ngIf="tech.executive_summary?.objective" class="sr-techdoc-paragraph">{{ tech.executive_summary?.objective }}</p>
                <div *ngIf="(tech.executive_summary?.impacts?.length || 0) > 0">
                  <div class="sr-techdoc-subtitle">Impactos</div>
                  <ul class="sr-techdoc-list">
                    <li *ngFor="let impact of tech.executive_summary?.impacts">{{ impact }}</li>
                  </ul>
                </div>
              </po-accordion-item>

              <po-accordion-item p-label="Detalhamento por Arquivo" *ngIf="(tech.files?.length || 0) > 0">
                <po-widget
                  class="sr-techdoc-widget"
                  *ngFor="let file of tech.files"
                  [p-title]="file.file || '-'"
                  p-no-shadow="true">
                  <div class="sr-techdoc-grid">
                    <div><strong>Linhas:</strong> {{ file.lines || '-' }}</div>
                    <div><strong>Papel:</strong> {{ file.role || '-' }}</div>
                    <div><strong>Mudanças:</strong> {{ file.changes || '-' }}</div>
                    <div><strong>Propósito:</strong> {{ file.purpose || '-' }}</div>
                  </div>
                  <div *ngIf="(file.dependencies?.length || 0) > 0">
                    <div class="sr-techdoc-subtitle">Dependências</div>
                    <ul class="sr-techdoc-list">
                      <li *ngFor="let dep of file.dependencies">{{ dep }}</li>
                    </ul>
                  </div>
                </po-widget>
              </po-accordion-item>

              <po-accordion-item p-label="Qualidade e Riscos" *ngIf="tech.quality_risks">
                <div *ngIf="(tech.quality_risks?.best_practices?.length || 0) > 0">
                  <div class="sr-techdoc-subtitle">Boas Práticas</div>
                  <ul class="sr-techdoc-list">
                    <li *ngFor="let item of tech.quality_risks?.best_practices">{{ item }}</li>
                  </ul>
                </div>
                <div *ngIf="(tech.quality_risks?.risks?.length || 0) > 0">
                  <div class="sr-techdoc-subtitle">Riscos</div>
                  <ul class="sr-techdoc-list">
                    <li *ngFor="let item of tech.quality_risks?.risks">{{ item }}</li>
                  </ul>
                </div>
                <div *ngIf="(tech.quality_risks?.suggestions?.length || 0) > 0">
                  <div class="sr-techdoc-subtitle">Sugestões</div>
                  <ul class="sr-techdoc-list">
                    <li *ngFor="let item of tech.quality_risks?.suggestions">{{ item }}</li>
                  </ul>
                </div>
              </po-accordion-item>

              <po-accordion-item p-label="Testes e Deploy" *ngIf="tech.tests_deploy">
                <div *ngIf="(tech.tests_deploy?.tests?.length || 0) > 0">
                  <div class="sr-techdoc-subtitle">Testes</div>
                  <ul class="sr-techdoc-list">
                    <li *ngFor="let item of tech.tests_deploy?.tests">{{ item }}</li>
                  </ul>
                </div>
                <div *ngIf="(tech.tests_deploy?.deploy?.length || 0) > 0">
                  <div class="sr-techdoc-subtitle">Deploy</div>
                  <ul class="sr-techdoc-list">
                    <li *ngFor="let item of tech.tests_deploy?.deploy">{{ item }}</li>
                  </ul>
                </div>
              </po-accordion-item>

              <po-accordion-item p-label="TDN" *ngIf="tech.tdn">
                <div class="sr-techdoc-grid">
                  <div><strong>Situação:</strong> {{ tech.tdn?.situation || '-' }}</div>
                  <div><strong>Solução:</strong> {{ tech.tdn?.solution || '-' }}</div>
                </div>
                <div *ngIf="(tech.tdn?.suggested_labels?.length || 0) > 0">
                  <div class="sr-techdoc-subtitle">Labels Sugeridas</div>
                  <div class="sr-techdoc-chip-wrap">
                    <span class="sr-techdoc-chip" *ngFor="let label of tech.tdn?.suggested_labels">{{ label }}</span>
                  </div>
                </div>
                <div *ngIf="(tech.tdn?.related_docs?.length || 0) > 0">
                  <div class="sr-techdoc-subtitle">Docs Relacionados</div>
                  <ul class="sr-techdoc-list">
                    <li *ngFor="let doc of tech.tdn?.related_docs">
                      <a *ngIf="isHttpLink(doc)" [href]="doc" target="_blank" rel="noopener noreferrer">{{ doc }}</a>
                      <span *ngIf="!isHttpLink(doc)">{{ doc }}</span>
                    </li>
                  </ul>
                </div>
              </po-accordion-item>

            </po-accordion>
          </div>
        </div>
      </div>

    </po-tab>

  </po-tabs>

  <po-modal
    #overallFeedbackModal
    p-title="Classificar review"
    p-size="md"
    [p-primary-action]="overallFeedbackModalCloseAction"
    p-click-out="true">
    <div class="sr-overall-feedback-modal-body">
      <app-review-feedback
        [findingKind]="'overall'"
        [resourceType]="resourceType"
        [resourceId]="resourceId"
        [initialResolution]="overallFeedback?.resolution ?? null"
        [initialComment]="overallFeedback?.comment"
        [feedbackId]="overallFeedback?.id"
        (feedbackChanged)="onFeedbackChanged($event)">
      </app-review-feedback>
      <app-review-other-feedback
        [feedbacks]="otherOverallFeedback"
        [overall]="true"
        (removed)="onOtherFeedbackRemoved($event)">
      </app-review-other-feedback>
      <div class="sr-overall-feedback-hint" *ngIf="files.length > 1 || isIssue">
        Aplica-se ao review completo — todos os arquivos{{ isIssue ? ' e changesets' : '' }}.
      </div>
    </div>
  </po-modal>

  <po-modal
    #deleteReviewModal
    [p-title]="deleteModalTitle"
    p-size="sm"
    [p-primary-action]="deleteReviewPrimaryAction"
    [p-secondary-action]="deleteReviewSecondaryAction"
    p-click-out="false">
    <div class="sr-delete-modal-body">
      <p>
        Você está prestes a {{ deleteActionVerb }} o review
        <strong>{{ deleteDisplayName }}</strong>
        ({{ resourceTypeLabel || 'review' }}){{ isSharedReviewContext ? ' da sua lista' : '' }}.
      </p>
      <p>{{ deleteDescription }}</p>
    </div>
  </po-modal>
<!-- Publicar escreve no diff de um Pull Request que outras pessoas acompanham, e apagar
     comentário depois é manual, um a um. Por isso confirma. -->
<po-modal
  #publishCommentsModal
  p-title="Publicar no Pull Request"
  p-size="md"
  [p-primary-action]="publishCommentsPrimaryAction"
  [p-secondary-action]="publishCommentsSecondaryAction">
  <p>
    Os achados deste review virão como comentários no diff do Pull Request
    <strong *ngIf="publishCommentsTarget">{{ publishCommentsTarget }}</strong>, cada um na sua
    linha. Quem acompanha o PR vai vê-los.
  </p>
  <!-- O provedor mostra como autor o dono da credencial de serviço, não quem clicou; o
       nome de quem publicou vai na assinatura de cada comentário (decisão 0038 do backend). -->
  <p class="sr-publish-note">
    Os comentários saem pela conta de serviço do Smart Review, assinados com o seu nome.
  </p>
  <p class="sr-publish-note">
    Publicar de novo não duplica: um achado já comentado é ignorado.
  </p>
</po-modal>


  <!-- Visualizador de código (diff/standalone) — reutilizado pela aba Code Review e pelo modo só-fonte -->
  <ng-template #sourceViewerTpl>
    <div class="po-row po-mt-2 sr-diff-workspace-row" *ngIf="!loading">
      <div class="po-md-12">
        <app-review-monaco-viewer
          #monacoViewer
          [isStandalone]="viewerStandaloneMode"
          [fitContainer]="sourceOnly"
          [answer]="answer"
          [diffPair]="diffPair"
          [standaloneSource]="viewerStandaloneSource"
          [sourceLanguage]="viewerSourceLanguage"
          [loading]="loading"
          [annotationsPanelCollapsed]="annotationsPanelCollapsed"
          [activeAnnotationLine]="activeAnnotationLine"
          [resourceType]="resourceType"
          [resourceId]="resourceId"
          [changesetContextLabel]="diffChangesetContextLabel"
          [changesetFreshness]="changesetFreshness"
          [answerArtifactId]="selectedAnswerArtifactId"
          [emptyAnalysisMessage]="emptyAnalysisMessage"
          [feedbackByFindingId]="feedbackByFindingId"
          [otherFeedbackByFindingId]="otherFeedbackByFindingId"
          (activeAnnotationLineChange)="activeAnnotationLine = $event"
          (annotationsPanelCollapsedChange)="setAnnotationsPanelCollapsed($event)"
          (feedbackChanged)="onFeedbackChanged($event)"
          (otherFeedbackRemoved)="onOtherFeedbackRemoved($event)">
        </app-review-monaco-viewer>
      </div>
    </div>
  </ng-template>

</ng-template>
<!-- fim #shellContent -->
<notificationComponentHM></notificationComponentHM>
